import { message } from "ant-design-vue"
import {ItemType_Tb1688} from "@/utils/constant/item"
import tb1688Handler from '@/views/order_before/components/orders_row/row_item_right_buttons_td/components/option_goods_btns/components/search_goods_by_keyword_modal/search_keyword_platform_handlers/tb1688/handler'


var tb1688ItemInfo= { items: [],info:ItemType_Tb1688,loading:false,handler:tb1688Handler,hasPagination:true,pageSize:60, currentPage:1, total:0}


const state = () => ({
  tb1688ItemInfo,
})

var allItemInfos =[tb1688ItemInfo]
var itenInfoMap = []
allItemInfos.map(info=>{
  itenInfoMap[info.info.type] = info
})


const getters = {
  searchKeyword: (state) => state.searchKeyword,
  itemInfos: (state) => {
    var itemInfos = [
      state.tb1688ItemInfo,
      ]
    return itemInfos
  }
}

function getItemInfoByType(state,type){
  var info = null
  switch(type){
    case ItemType_Tb1688.type:
    info = state.tb1688ItemInfo;break;

    }

  return info
}


const mutations = {
  setSearchLoadding(state, {type,loading}) {
    var itemInfo = getItemInfoByType(state,type)
    itemInfo.loading = loading
  },
  setKeyword(state, keyword) {
    if(!keyword)return
    state.keyword = keyword
  },
  setItems(state, {items,type}) {
    var itemInfo = getItemInfoByType(state,type)
    itemInfo.items = items
  },
}


const actions = {
  StartSearchKeyword({commit,state},{type,dyItemOrderInfo}){
    if(!state.keyword)return message.warn("请输入关键字")
    commit("setSearchLoadding",{type,loading:true})
    var info = itenInfoMap[type]
    console.log(info)
    debugger
    info.handler.StartSearchKeyword({keyword:state.keyword},dyItemOrderInfo,info).then(items=>{

      commit("setItems",{items:items,type})
      commit("setSearchLoadding",{type,loading:false})
    })
  },
}

export default { state, getters, mutations, actions}
